module.exports = __webpack_public_path__ + "img/img6.90715b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img6.jpg
// module id = 342
// module chunks = 0